'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loginFormStates = exports.loginFormStates = {
  login: 'login',
  forgot: 'forgot password',
  reset: 'reset password',
  unlock: 'unlock account'
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/auth.js
// module id = 356
// module chunks = 1